import { TOKEN_TYPE_ACCESS_TOKEN, rsosApi } from '../rsosApi';

const getTextFrom911BaseEndpoint = orgName => {
  return `v1/tf911/psap/${orgName}/conversation`;
};

/**
 * Redux Toolkit baseQueryFn accepted args
 */
const baseQueryArgs = {
  headers: {
    Authorization: `Bearer ${TOKEN_TYPE_ACCESS_TOKEN}`,
  },
  validateStatus: (response, result) => {
    return response.status >= 200 && response.status < 300;
  },
};

const baseExtraOptions = {
  tokenType: TOKEN_TYPE_ACCESS_TOKEN,
};

/**
 * Extends the rsosApi for text-from-911 endpoints.
 * Authorization header must be manually included to tell RTK which token to use
 * otherwise it will use the access token
 */
export const textFrom911Api = rsosApi.injectEndpoints({
  endpoints: builder => ({
    getConversationMetadata: builder.query({
      query: ({ callerID, orgName }) => ({
        ...baseQueryArgs,
        url: `${getTextFrom911BaseEndpoint(orgName)}/+${callerID}`,
        method: 'GET',
      }),
      extraOptions: {
        ...baseExtraOptions,
      },
    }),
    createConversation: builder.query({
      query: ({ callerID, orgName, startMessage }) => ({
        ...baseQueryArgs,
        url: `${getTextFrom911BaseEndpoint(orgName)}/+${callerID}`,
        method: 'POST',
        body: JSON.stringify({
          start_message: startMessage,
        }),
      }),
      extraOptions: {
        ...baseExtraOptions,
      },
    }),
    endConversation: builder.query({
      query: ({ callerID, orgName }) => ({
        ...baseQueryArgs,
        url: `${getTextFrom911BaseEndpoint(orgName)}/+${callerID}`,
        method: 'PUT',
      }),
      extraOptions: {
        ...baseExtraOptions,
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetConversationMetadataQuery,
  useLazyGetConversationMetadataQuery,
  useCreateConversationQuery,
  useLazyCreateConversationQuery,
  useEndConversationQuery,
  useLazyEndConversationQuery,
} = textFrom911Api;
